import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {Brand} from "../../../../core/models/brand";
import {Advertiser} from "../../../../core/models/advertiser";
import {IntegrationInviteDao} from "../../../../core/services/dao/integrationInviteDao";
import * as moment from "moment-timezone";
import {IntegrationInvite, IntegrationInviteStatus} from "../../../../core/models/integrationInvite";
import {MatLegacySnackBar as MatSnackBar} from "@angular/material/legacy-snack-bar";
import {ChickenTestService} from "../../../shared/chickenTest/chicken-test-service";
import {BaseIntegrationOptions} from "../../../shared/integration-options";
import {UserDao} from "../../../../core/services/dao/userDao";

@Component({
  selector: 'app-manage-integrations',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss']
})
export class ManageIntegrationsComponent implements OnInit, OnDestroy {
  @Output() onBackClick = new EventEmitter<any>();
  @Output() onInviteClick = new EventEmitter<any>();
  @Output() onAddAnotherClick = new EventEmitter<any>();
  @Input() selectedBrand: Brand;
  @Input() advertiser: Advertiser;
  @Input() selectedIntegration: any;
  @Input() isStandalone: boolean;
  sentInvites: IntegrationInvite[] = [];
  statuses = IntegrationInviteStatus;
  subs = [];
  integrationOptions: any[];
  isAdmin = false;

  constructor(
      private integrationInviteDao: IntegrationInviteDao,
      private snackBar: MatSnackBar,
      private chickenTest: ChickenTestService,
      private userDao: UserDao
  ) {
    this.integrationOptions = [...BaseIntegrationOptions];
    let user = this.userDao.getCurrentUser();
    if (user) {
      this.isAdmin = user.isAdmin;
    }
  }
  ngOnInit() {
    // let sub = this.integrationInviteDao.loadByBrand(this.selectedBrand.id).subscribe(invites => {
    //   this.sentInvites = this.selectedIntegration ? invites.filter(i => i.integrations.includes(this.selectedIntegration.type)) : invites;
    // })
    // this.subs.push(sub)
  }

  getManageText() {
    return this.selectedIntegration ? this.selectedIntegration.name : 'Integrations'
  }

  inviteDisabled(invite: IntegrationInvite) {
    return invite.status === this.statuses.disabled || invite.completed
  }

  getDisplayDate(date) {
    return moment(date).format('MMMM DD, YYYY')
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe())
  }

  getStatusText(invite) {
    return invite.completed ? 'Active' : invite.status === this.statuses.expired ? 'Expired' : 'Pending'
  }

  getIntStatus(intType: string) {
    let found = this.selectedBrand.integrations.find(i => (i.type === intType && i.enabled))
    return found ? 'Active' : 'Pending'
  }

  getIntImg(intType: string) {
    let found = this.integrationOptions.find(i => i.type === intType);
    return found.img
  }

  resend(invite) {
    const body = {
      brandName: this.selectedBrand.name,
      name: invite.name,
      email: invite.email,
      link: invite.link
    };
    // let sub = this.integrationInviteDao.sendEmail(body).subscribe(() => {
    //   this.snackBar.open(`Invite successfully resent`, 'Dismiss', {
    //     duration: 5000,
    //     verticalPosition: 'top'
    //   });
    // });
    // this.subs.push(sub)
  }

  disable(invite) {
    let csub = this.chickenTest.test('disable this integration invite link', 'Disable', 'Cancel').subscribe(res => {
      if (res) {
        // let sub = this.integrationInviteDao.disableInvite(invite.id).subscribe(
        //     disabled => {
        //       invite.status = IntegrationInviteStatus.disabled;
        //       this.snackBar.open(`Link for this invite has been deactivated`, 'Dismiss', {
        //         duration: 5000,
        //         verticalPosition: 'top'
        //       });
        //     },
        //     err => console.error(err)
        // );
        // this.subs.push(sub);
      }
    });
    this.subs.push(csub);
  }

  inviteClick() {
    this.onInviteClick.emit()
  }

  addAnotherClick() {
    this.onAddAnotherClick.emit()
  }

  back() {
    this.onBackClick.emit()
  }

}